export type IconProps = {
  size?: number;
  className?: string;
};

export * from './WarningIcon';
export * from './PrintIcon';
export * from './CheckMarkIcon';
export * from './PlusIcon';
export * from './MinusIcon';
export * from './LeftCaretIcon';
export * from './SelectTickIcon';
export * from './UnsortedIcon';
export * from './SortAscIcon';
export * from './SortDescIcon';
export * from './DownArrowIcon';
export * from './UpArrowIcon';
export * from './CrossIcon';
export * from './RotateSolidIcon';
export * from './MoneyBillIcon';
export * from './BoxIcon';
export * from './DollarSignIcon';
export * from './CodeBranchIcon';
export * from './SearchIcon';
export * from './LoadingIcon';
export * from './LinkIcon';
export * from './HamburgerIcon';
export * from './RestartIcon';
export * from './LoadingIcon';
export * from './ExpandIcon';
export * from './DangerIcon';
export * from './LeftArrowIcon';
export * from './RightArrowIcon';
export * from './DotIcon';
export * from './QuestionMarkIcon';
export * from './UserCircleIcon';
export * from './RightRotateIcon';
export * from './VarianceIcon';
export * from './InfoSignIcon';
export * from './WifiIcon';
